import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=auth
  const [activeCompanyId, setActiveId] = useState(
    localStorage.getItem("activeCompanyId") || null
  );

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      const stored = localStorage.getItem("activeCompanyId");
      const ids = data.memberships.map((m) => m.company_id);
      if (!stored || !ids.includes(stored)) {
        if (data.memberships.length === 1) {
          localStorage.setItem("activeCompanyId", data.memberships[0].company_id);
          setActiveId(data.memberships[0].company_id);
        } else {
          setActiveId(null);
        }
      } else {
        setActiveId(stored);
      }
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const verifyMfa = async (mfa_token, code) => {
    await api.post("/auth/verify-mfa", { mfa_token, code });
    return fetchMe();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const setActiveCompany = (id) => {
    localStorage.setItem("activeCompanyId", id);
    setActiveId(id);
  };

  const activeMembership =
    user && user.memberships
      ? user.memberships.find((m) => m.company_id === activeCompanyId)
      : null;

  return (
    <AuthContext.Provider
      value={{ user, setUser, fetchMe, verifyMfa, logout, activeCompanyId,
               setActiveCompany, activeMembership }}
    >
      {children}
    </AuthContext.Provider>
  );
}
